<template>
  <div class="v2-card" data-qid="engagement-recent-activity">
    <div class="v2-card__head">
      <h3>{{ $t('projects.engagement.overview.recent_activity') }}</h3>
      <a href="#" class="v2-link" @click.prevent="$emit('open-tab', 'history')">{{ $t('projects.tab.history') }}</a>
    </div>
    <div class="v2-card__body">
      <ActivityFeed compact
                    :log="project.who_am_i + '::' + project.id"
                    :here="project"
                    :limit="limit"
                    :empty-text="$t('system.no_data')"
      />
    </div>
  </div>
</template>

<script>
import ActivityFeed from '@/components/activity/feed/ActivityFeed.vue';

// The latest entries of the project history, for the Overview
export default {
  name: 'EngagementRecentActivity',
  props: {
    project: {
      type: Object,
      required: true
    },
    limit: {
      type: Number,
      default: 4
    }
  },
  components: {
    ActivityFeed
  }
}
</script>
